import { useEffect, useState } from 'react'
import {
  getEffectiveSessionElapsedMs,
  subscribeSessionWallClockPause,
} from './sessionTimerPause'
import { mandatorySessionExtensionSlotMs } from './mandatorySession.constants'

const DEFAULT_EXTENSION_SLOT_MS = mandatorySessionExtensionSlotMs()

/** Remaining ms until mandatory max-session limit; null when feature off or no anchor. */
export function useMandatoryReloginRemainingMs(
  maxMinutes: number,
  sessionLoginAtMs: number,
  maxSessionExtensionCount = 0,
  extensionSlotMs = DEFAULT_EXTENSION_SLOT_MS
): number | null {
  const [remainingMs, setRemainingMs] = useState<number | null>(null)

  useEffect(() => {
    if (maxMinutes <= 0 || sessionLoginAtMs <= 0) {
      setRemainingMs(null)
      return
    }
    const baseMaxMs = maxMinutes * 60 * 1000
    const effectiveMaxMs =
      baseMaxMs + maxSessionExtensionCount * extensionSlotMs
    const tick = () => {
      const elapsed = getEffectiveSessionElapsedMs(sessionLoginAtMs)
      setRemainingMs(Math.max(0, effectiveMaxMs - elapsed))
    }
    tick()
    const id = window.setInterval(tick, 1000)
    return () => window.clearInterval(id)
  }, [maxMinutes, sessionLoginAtMs, maxSessionExtensionCount, extensionSlotMs])

  useEffect(() => {
    if (maxMinutes <= 0 || sessionLoginAtMs <= 0) return
    const baseMaxMs = maxMinutes * 60 * 1000
    const effectiveMaxMs =
      baseMaxMs + maxSessionExtensionCount * extensionSlotMs
    return subscribeSessionWallClockPause(() => {
      const elapsed = getEffectiveSessionElapsedMs(sessionLoginAtMs)
      setRemainingMs(Math.max(0, effectiveMaxMs - elapsed))
    })
  }, [maxMinutes, sessionLoginAtMs, maxSessionExtensionCount, extensionSlotMs])

  return remainingMs
}

export function formatSessionLoginAt(ms: number): string {
  if (!ms || ms <= 0) return ''
  try {
    return new Date(ms).toLocaleString(undefined, {
      dateStyle: 'short',
      timeStyle: 'short',
    })
  } catch {
    return ''
  }
}
